module.exports = __webpack_public_path__ + "img/81.a81ddb9e.png";